import analytics from "web/script/analytics/analytics";
import baustein from "baustein";
import "web/script/components/image-gallery";
import "web/script/components/product-image-card";
import "web/script/components/save-for-later-button";
import "web/script/components/save-for-later-signup-prompt";
import "web/script/components/tracked-link";
import "web/script/components/buybuybuy-area";
export default baustein.register("product-overview", {
  defaultOptions: {},
  setupEvents: function setupEvents(add) {
    add("readMoreText", this._onReadMoreText);
  },
  _onReadMoreText: function _onReadMoreText() {
    analytics.event("product_overview", "read_more_details");
  }
});